import { configHelper as ch } from '@ilteducation/config';

/**
 * Base URL for the content-registry service.
 *
 * `isGlobal` is on: content lives on the global shard regardless of the realm
 * the app is configured for. Read on call rather than at module load, so the
 * config is initialised by the time it is asked for.
 */
export const contentRegistryUrl = () => ch.getApiUrl('content-registry', true);

export const babelfishUrl = () => ch.getApiUrl('babelfish', true);

export default contentRegistryUrl;
